import React from "react";
import { Circle, CheckCircle2, XCircle, MinusCircle } from "lucide-react";

/**
 * ChecklistStatusIcon
 * Visual indicator for a checklist item state.
 * value: true | false | "na" | null/undefined
 * - null/undefined  -> gray outline circle (default)
 * - true            -> green check circle (Conforme)
 * - false           -> red X circle (Non conforme)
 * - "na"            -> gray minus circle (N/A)
 *
 * Wrapper is `shrink-0 inline-flex` with explicit size to prevent
 * flex distortion on narrow (mobile) viewports.
 */
export const ChecklistStatusIcon = ({ value, size = "md", className = "", testId }) => {
  const sizeClasses = size === "sm" ? "w-5 h-5" : "w-6 h-6";
  const iconClasses = size === "sm" ? "w-5 h-5" : "w-6 h-6";

  let Icon = Circle;
  let colorClass = "text-slate-400 dark:text-slate-500";
  let label = "Da valutare";

  if (value === true) {
    Icon = CheckCircle2;
    colorClass = "text-emerald-500 dark:text-emerald-400";
    label = "Conforme";
  } else if (value === false) {
    Icon = XCircle;
    colorClass = "text-rose-500 dark:text-rose-400";
    label = "Non conforme";
  } else if (value === "na") {
    Icon = MinusCircle;
    colorClass = "text-slate-400 dark:text-slate-500";
    label = "Non applicabile";
  }

  return (
    <span
      className={`shrink-0 inline-flex items-center justify-center ${sizeClasses} ${className}`}
      aria-label={label}
      title={label}
      data-testid={testId}
      data-state={value === true ? "yes" : value === false ? "no" : value === "na" ? "na" : "pending"}
    >
      <Icon className={`${iconClasses} ${colorClass}`} strokeWidth={2} />
    </span>
  );
};

export default ChecklistStatusIcon;
